/** Plain-language badge tooltips shown on hover in performance pages. */

const BADGE_FRIENDLY_DESCRIPTIONS = {
  on_time_bronze:
    'You finished at least 5 tasks on time, with 80% or more delivered by their due date.',
  on_time_silver:
    'Strong consistency — 90% or more of your completed tasks were on time this month.',
  on_time_gold:
    'Excellent punctuality — 95% or more on-time delivery with at least 10 tasks completed.',
  streak_4:
    'You kept an on-time streak going for 4 weeks in a row. Keep the momentum!',
  streak_8:
    'Eight weeks of on-time delivery — you are building a reliable habit.',
  streak_12:
    'Twelve weeks without breaking your on-time streak. Truly unstoppable!',
  velocity_bronze:
    'You completed 15 or more tasks in the last 30 days.',
  velocity_silver:
    'High output — you closed 25 or more tasks in the last month.',
  velocity_gold:
    'Exceptional pace — 40 or more tasks completed in 30 days.',
  zero_overdue:
    'You had no overdue tasks while completing at least 5 assignments. A clean slate!',
  fast_responder:
    'You typically pick up and respond to tasks within 4 hours on average.',
  engager_bronze:
    'You stayed active on your work — comments, updates, and task activity added up.',
  engager_silver:
    'You contribute regularly across your tasks and keep things moving for the team.',
  engager_gold:
    'Top collaboration — you are highly engaged across tasks and teammates.',
  commentator:
    'You left 20 or more helpful comments in the last 30 days.',
  observer_hero:
    'As an observer, you follow up promptly on the tasks you are watching.',
  checklist_master:
    'You completed 25 or more checklist items — great attention to detail.',
  daily_reporter:
    'You shared 15 or more daily progress updates this month.',
  rising_star:
    'Your overall performance score reached 50 or higher — you are on the rise!',
  high_achiever:
    'Your performance score hit 70 or higher with solid, consistent results.',
  elite_performer:
    'Elite performance — your score reached 85 or higher with strong consistency.',
};

export function getFriendlyBadgeDescription(badge) {
  if (!badge) return '';
  if (badge.key && BADGE_FRIENDLY_DESCRIPTIONS[badge.key]) {
    return BADGE_FRIENDLY_DESCRIPTIONS[badge.key];
  }
  return badge.description || badge.name || '';
}

export function getBadgeTooltip(badge) {
  if (!badge) return '';
  const description = getFriendlyBadgeDescription(badge);
  if (badge.times_earned > 1) {
    return `${description} You've earned this badge ${badge.times_earned} times.`;
  }
  return description;
}
